import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import Page404 from '@/pages/404';
import ReceptionPage from '@/pages/inventory/reception/reception-page';
import OrdersPage from '@/pages/izzi/orders/orders-page';
import SeriesPage from '@/pages/izzi/series/series-page';

import DashboardTopLayout from './components/layouts/dashboard-top/dashboard-top-layout';
import { AppProvider } from './components/providers/app/app-provider';
import ClaimProvider from './components/providers/auth/claim-provider';
import { AuthRequired } from './components/providers/auth/guards';
import { HttpProvider } from './components/providers/http/http-provider';

/**
 * HttpProvider
 * Libre para agregar dominio de peticiones que estaran disponibles a cualquier nivel de la aplicación via useHttp()
 */

/**
 * AppProvider
 * Libre para agregar proveedores que se comparten a cualquier nivel de la aplicación via useApp()
 */

/**
 *
 * La plantilla cuenta con 3 wrappers, DashboardTopLayout, DashboardLayout y SimpleLayout
 */

function WrapperDashboard() {
  return (
    <HttpProvider>
      <ClaimProvider>
        <AppProvider>
          <DashboardTopLayout>
            <Outlet />
          </DashboardTopLayout>
        </AppProvider>
      </ClaimProvider>
    </HttpProvider>
  );
}

export function RouteManager() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthRequired>
            <WrapperDashboard />
          </AuthRequired>
        }
      >
        <Route path="/" element={<ReceptionPage />} />
        <Route path="/inventory/reception" element={<ReceptionPage />} />
        <Route path="/izzi/series" element={<SeriesPage />} />
        <Route path="/izzi/orders" element={<OrdersPage />} />

        {/* Redirecciones de rutas consolidadas */}
        <Route path="/izzi/kit-pairs" element={<Navigate to="/inventory/reception" replace />} />
        <Route path="/inventory/validation" element={<Navigate to="/izzi/series" replace />} />
        <Route path="/inventory/audit" element={<Navigate to="/izzi/series" replace />} />
        <Route path="/izzi/scan" element={<Navigate to="/inventory/reception" replace />} />
        <Route path="/izzi/quarantine" element={<Navigate to="/izzi/series" replace />} />

        {/* <Route path="/coverage/create-version" element={<CoverageAddPage />} /> */}
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  );
}
